import axios from 'axios'
import { BUSCAR_MAPA_ITINERARIO_IDA, BUSCAR_MAPA_ITINERARIO_VOLTA } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { RESPONSE_ERROR_HANDLER_POSTPONE_HEADER } from '../../util/responseUtil'
import { URL } from '../../util/ambienteActions';
import { salvarCacheMapa, carregarCacheMapa } from '../../util/offlineStorage';
import { showInfoMsg } from '../../util/messagesUtil';

const OFFLINE_AWARE_CONFIG = {
  headers: {
    ...SLOW_REQUEST_CONFIG.headers,
    [RESPONSE_ERROR_HANDLER_POSTPONE_HEADER]: true
  }
}

export default function buscarMapaVeiculoItinerario (codItinerario, codOrigem, codDestino, seIda, categoria) {
  const url = `${URL}/mapas-veiculos/itinerario/${codItinerario}/origem/${codOrigem}/destino/${codDestino}?categoria=${categoria}`;
  const type = seIda ? BUSCAR_MAPA_ITINERARIO_IDA : BUSCAR_MAPA_ITINERARIO_VOLTA;

  return dispatch => axios.get(url, OFFLINE_AWARE_CONFIG)
    .then(response => {
      salvarCacheMapa(codItinerario, codOrigem, codDestino, categoria, response.data);
      return dispatch({ type, payload: response });
    })
    .catch(erro => {
      if (!navigator.onLine || !erro.response) {
        const cache = carregarCacheMapa(codItinerario, codOrigem, codDestino, categoria);
        if (cache) return dispatch({ type, payload: { data: cache } });
        showInfoMsg('Mapa de poltronas indisponível offline. Carregue os itinerários enquanto estiver online.');
        return dispatch({ type, payload: { data: [] } });
      }
      throw erro;
    });
}
